import { render, staticRenderFns } from "./intranetIndex.vue?vue&type=template&id=0881e474&scoped=true&"
import script from "./intranetIndex.vue?vue&type=script&lang=js&"
export * from "./intranetIndex.vue?vue&type=script&lang=js&"
import style0 from "./intranetIndex.vue?vue&type=style&index=0&id=0881e474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881e474",
  null
  
)

export default component.exports